import React from "react";

const Testimonial = (props) => {
  const { review, name, imgURL } = props.testimonial;
  return (
    <figure className="snip1274 me-4 col-md-3">
      <i className="ion-quote"></i>
      <blockquote>{review}</blockquote>
      <img src={imgURL} alt="sample51" />
      <div className="author">
        <h5 style={{ marginLeft: "30px", color: "black" }}>{name}</h5>
      </div>
    </figure>
  );
};

export default Testimonial;
